/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Form,
  Button,
  OverlayTrigger,
  Popover,
  PopoverBody,
} from 'react-bootstrap';

interface Props {
  draft: any;
  setDraft: (v: any) => void;
  availableGroups: any[];
  onManage: () => void;
}

const GroupSelector: React.FC<Props> = ({
  draft,
  setDraft,
  availableGroups,
  onManage,
}) => {
  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <div>
          <Form.Label>Scoring Group</Form.Label>
          <OverlayTrigger
            trigger="hover"
            placement="right"
            overlay={
              <Popover>
                <PopoverBody>
                  Scoring groups categorize questions within a section and allow
                  grouped score reporting (e.g., “CO₂ Emissions” group).
                </PopoverBody>
              </Popover>
            }
          >
            <i
              className="bi bi-info-circle-fill text-muted ms-1"
              style={{ cursor: 'pointer' }}
            />
          </OverlayTrigger>
        </div>

        <Button size="sm" variant="link" className="my-0" onClick={onManage}>
          Manage
        </Button>
      </div>

      <Form.Select
        value={draft.group_id}
        onChange={(e) => setDraft({ ...draft, group_id: e.target.value })}
      >
        <option value="">Select a scoring group</option>
        {availableGroups.map((group) => (
          <option key={group.id} value={group.id}>
            {group.title}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default GroupSelector;
